module.exports = __webpack_public_path__ + "media/images/lgt/gallery3-2dd84c8838386d87b42e2b94cfadfff9.jpg";